import { render, staticRenderFns } from "./InformationPlatform.vue?vue&type=template&id=311ffc44&scoped=true&"
import script from "./InformationPlatform.vue?vue&type=script&lang=js&"
export * from "./InformationPlatform.vue?vue&type=script&lang=js&"
import style0 from "./InformationPlatform.vue?vue&type=style&index=0&id=311ffc44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ffc44",
  null
  
)

export default component.exports